import React from 'react';
import { useFormik } from 'formik';
import styled from 'styled-components';
import * as Yup from 'yup';
import { AuthCodeInput, Button, ButtonCall, ButtonRetry, ModalContent, ModalHeader, ModalText, ModalTitle } from 'components';
import { theme, toRem } from 'design';
import Validations from 'lib/Validations';
import Form from 'screens/Error/Form';
import { formatMobile } from 'utils/strings';
import { NeedHelpLink } from './styles';

interface IVerificationFormProps {
  mobile: string;
  isLoading: boolean;
  isResendLoading: boolean;
  errorMessages: string[];
  onSubmit: (verificationCode: string) => void;
  resendVerificationCode: () => void;
  resendCall?: () => void;
  showCallButton?: boolean;
}

const StyledButtonRetry = styled(ButtonRetry)`
  margin-top: ${toRem(theme.space['2xl'])};
`;

const StyledButton = styled(Button)`
  margin-top: ${toRem(theme.space['2xl'])};
`;

const MobileVerificationForm: React.FC<IVerificationFormProps> = ({ mobile, isLoading, isResendLoading, errorMessages, onSubmit, resendVerificationCode, resendCall, showCallButton = false }) => {
  const validationSchema = Yup.object().shape({
    code: Validations.verificationCodeValidationSchema,
  });

  const { handleSubmit, dirty, isValid, setFieldValue } = useFormik({
    initialValues: {
      code: '',
    },
    onSubmit: (values: { code: string }) => {
      onSubmit(values.code);
    },
    validateOnChange: true,
    validationSchema,
  });

  return (
    <>
      <ModalHeader>
        <ModalTitle>Verify Mobile Number</ModalTitle>
        <ModalText marginTop={theme.space.md}>
          Enter the code sent to your mobile number:
          <br />
          <strong>{formatMobile(mobile)}</strong>
        </ModalText>
      </ModalHeader>
      <ModalContent>
        <Form onSubmit={handleSubmit}>
          <AuthCodeInput errorMessages={errorMessages} onChange={(val) => setFieldValue('code', val)} />
          <StyledButton data-cy="submit-button" type="submit" label="Verify" disabled={isLoading || !(isValid && dirty)} isProcessing={isLoading} />
        </Form>
        <StyledButtonRetry dataCy="resend-verification-code" label="Resend Verification Code" onClick={resendVerificationCode} isLoading={isResendLoading} />
        {showCallButton && resendCall && <ButtonCall onClick={resendCall} />}
        <NeedHelpLink>Need some help?</NeedHelpLink>
      </ModalContent>
    </>
  );
};

export default MobileVerificationForm;
